import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class DeviceTypeService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
		this._rc = new RealtimeClient();
	}

	/**
	 * Get all  deviceTypes
	 * @param {String} type
	 */
	getAllDeviceTypes(callback) {
		const url = `/ecosystem/api/deviceTypes`;
		this._restClient.exec_get(url, callback);
	}

	/**
	 * Create a device type
	 * @param {Object} data
	 */
	createDeviceType(data, callback) {
		const url = `/ecosystem/api/deviceTypes`;
		const body = JSON.stringify(data);
		this._restClient.exec_post(url, body, callback);
	}

	/**
	 * Update a device type
	 * @param {String} deviceTypeId
	 */
	updateDeviceTypeById(deviceTypeId, data, callback) {
		const url = `/ecosystem/api/deviceTypes/${deviceTypeId}`;
		const body = JSON.stringify(data);
		this._restClient.exec_put(url, body, callback);
	}

	/**
	 * delete a device type
	 * @param {String} deviceTypeId
	 */
	deleteDeviceType(deviceTypeId, callback) {
		const url = `/ecosystem/api/deviceTypes/${deviceTypeId}`;
		this._restClient.exec_delete(url, callback);
	}

	subscribeDeviceTypes(callback) {
		this._rc.subscribe("ecosystem", "/deviceTypes", {}, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				callback(null, response);
			}
		});
	}
}
